import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { apiUrl } from '../apiConfig';
import 'bootstrap/dist/css/bootstrap.min.css';

const BRAND = '#facc15';
const BRAND_RGB = '250,204,21';

const fadeUp = { hidden:{ opacity:0, y:24 }, show:{ opacity:1, y:0, transition:{ duration:0.55, ease:[0.22,1,0.36,1] } } };

export default function Cadastro() {
  const { loginDireto } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nome_completo:'', username:'', password:'', confirmar_senha:'', telefone:'', empresa:'' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (form.password !== form.confirmar_senha) {
      setError('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(apiUrl('/api/register'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: form.username,
          password: form.password,
          nome_completo: form.nome_completo,
          telefone: form.telefone,
          empresa: form.empresa,
        }),
      });
      const data = await res.json();
      if (data.success && data.token) {
        loginDireto(data.token, data.user);
        navigate('/app');
      } else {
        setError(data.message || 'Erro ao criar conta');
      }
    } catch {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#020617', display:'flex', flexDirection:'column', fontFamily:'Inter, system-ui, sans-serif' }}>
      <style>{`
        * { box-sizing: border-box; }
        .input-dark { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #f1f5f9; border-radius: 12px; padding: 13px 16px; font-size: 0.9rem; transition: all 0.2s; width: 100%; }
        .input-dark:focus { outline: none; border-color: rgba(${BRAND_RGB},0.5); box-shadow: 0 0 0 3px rgba(${BRAND_RGB},0.08); background: rgba(255,255,255,0.07); }
        .input-dark::placeholder { color: rgba(241,245,249,0.28); }
        .btn-brand-full { background:${BRAND}; color:#020617; border:none; border-radius:12px; padding:14px 24px; font-weight:700; font-size:1rem; width:100%; cursor:pointer; transition:all 0.2s; }
        .btn-brand-full:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 8px 32px rgba(${BRAND_RGB},0.35); }
        .btn-brand-full:disabled { opacity:0.6; cursor:not-allowed; }
        .label-field { display:block; font-size:0.75rem; font-weight:600; color:rgba(241,245,249,0.45); margin-bottom:7px; text-transform:uppercase; letter-spacing:0.07em; }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* Navbar */}
      <nav style={{ padding:'0 24px', borderBottom:`1px solid rgba(${BRAND_RGB},0.1)`, background:'rgba(2,6,23,0.97)', backdropFilter:'blur(24px)', position:'sticky', top:0, zIndex:100 }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems:'center', height:60, justifyContent:'space-between' }}>
          <Link to="/" style={{ display:'flex', alignItems:'center', gap:10, textDecoration:'none' }}>
            <div style={{ width:30, height:30, borderRadius:8, background:`rgba(${BRAND_RGB},0.15)`, border:`1px solid rgba(${BRAND_RGB},0.3)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.9rem' }}>📊</div>
            <span style={{ fontWeight:800, color:BRAND, fontSize:'1rem' }}>Delator</span>
          </Link>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <span style={{ fontSize:'0.85rem', color:'rgba(241,245,249,0.4)' }}>Já tem conta?</span>
            <Link to="/login" style={{ fontSize:'0.85rem', color:BRAND, textDecoration:'none', fontWeight:600 }}>Entrar</Link>
          </div>
        </div>
      </nav>

      {/* Conteúdo */}
      <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 24px', position:'relative' }}>
        <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:700, height:500, borderRadius:'50%', pointerEvents:'none', background:`radial-gradient(ellipse, rgba(${BRAND_RGB},0.05) 0%, transparent 65%)` }}/>

        <motion.div initial="hidden" animate="show" variants={{ show:{ transition:{ staggerChildren:0.07 } } }}
          style={{ width:'100%', maxWidth:520, position:'relative', zIndex:2 }}>

          <motion.div variants={fadeUp} style={{ textAlign:'center', marginBottom:32 }}>
            <div style={{ width:52, height:52, borderRadius:14, background:`rgba(${BRAND_RGB},0.12)`, border:`1px solid rgba(${BRAND_RGB},0.25)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.5rem', margin:'0 auto 16px' }}>📊</div>
            <h1 style={{ fontSize:'1.7rem', fontWeight:900, color:'#f1f5f9', marginBottom:6 }}>Criar sua conta</h1>
            <p style={{ color:'rgba(241,245,249,0.4)', fontSize:'0.88rem', margin:0 }}>Acesse o sistema de auditoria de taxas</p>
          </motion.div>

          <motion.div variants={fadeUp}>
            <div style={{ background:'rgba(255,255,255,0.03)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:20, padding:32 }}>
              <form onSubmit={handleSubmit}>
                <div className="row g-3" style={{ marginBottom:4 }}>
                  <div className="col-12">
                    <label className="label-field">Nome completo *</label>
                    <input className="input-dark" name="nome_completo" type="text" placeholder="Seu nome completo" value={form.nome_completo} onChange={handleChange} required/>
                  </div>
                  <div className="col-sm-6">
                    <label className="label-field">Usuário *</label>
                    <input className="input-dark" name="username" type="text" placeholder="usuario" value={form.username} onChange={handleChange} required autoComplete="username"/>
                  </div>
                  <div className="col-sm-6">
                    <label className="label-field">Empresa</label>
                    <input className="input-dark" name="empresa" type="text" placeholder="Nome da empresa" value={form.empresa} onChange={handleChange}/>
                  </div>
                  <div className="col-sm-6">
                    <label className="label-field">Senha *</label>
                    <div style={{ position:'relative' }}>
                      <input className="input-dark" name="password" type={showPass ? 'text' : 'password'} placeholder="Mín. 6 caracteres" value={form.password} onChange={handleChange} required autoComplete="new-password" style={{ paddingRight:44 }}/>
                      <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'transparent', border:'none', color:'rgba(241,245,249,0.35)', cursor:'pointer', fontSize:'0.95rem', padding:0, lineHeight:1 }}>
                        {showPass ? '🙈' : '👁️'}
                      </button>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <label className="label-field">Confirmar senha *</label>
                    <input className="input-dark" name="confirmar_senha" type={showPass ? 'text' : 'password'} placeholder="Repita a senha" value={form.confirmar_senha} onChange={handleChange} required autoComplete="new-password"/>
                  </div>
                  <div className="col-12">
                    <label className="label-field">Telefone</label>
                    <input className="input-dark" name="telefone" type="tel" placeholder="(51) 99999-9999" value={form.telefone} onChange={handleChange}/>
                  </div>
                </div>

                {error && (
                  <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.28)', borderRadius:10, padding:'11px 16px', margin:'16px 0', fontSize:'0.85rem', color:'#fca5a5', display:'flex', alignItems:'center', gap:8 }}>
                    ⚠ {error}
                  </div>
                )}

                <button className="btn-brand-full" type="submit" disabled={loading} style={{ marginTop:20 }}>
                  {loading ? (
                    <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                      <span style={{ width:16, height:16, border:'2px solid rgba(2,6,23,0.3)', borderTopColor:'#020617', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>
                      Criando conta...
                    </span>
                  ) : 'Criar minha conta'}
                </button>

                <p style={{ textAlign:'center', fontSize:'0.78rem', color:'rgba(241,245,249,0.3)', marginTop:16, marginBottom:0 }}>
                  Ao criar conta você aceita os termos de uso do sistema.
                </p>
              </form>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} style={{ textAlign:'center', marginTop:20 }}>
            <span style={{ fontSize:'0.85rem', color:'rgba(241,245,249,0.35)' }}>Já tem conta? </span>
            <Link to="/login" style={{ fontSize:'0.85rem', color:BRAND, textDecoration:'none', fontWeight:600 }}>Entrar</Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
